var exports = {
  "wrapper": "xaee3c4fa--f5cd84--wrapper",
  "has_counter": "xaee3c4fa--f5cd84--has_counter",
  "counter": "xaee3c4fa--f5cd84--counter",
  "_max": "xaee3c4fa--f5cd84--_max",
  "_size_xs": "xaee3c4fa--f5cd84--_size_xs",
  "_size_m": "xaee3c4fa--f5cd84--_size_m",
};

module.exports = exports;
